import { Box } from '@chakra-ui/react';
import React from 'react';

import Link from '../../../../Link';
import { Text } from '../../../../Text';
import { SubnavSection } from '../../../types';
import { useNavigation } from '../../Navigation.context';
import * as Styles from './Template.module.scss';

interface LinkSectionProps {
  url: string;
  children: React.ReactNode;
}

interface MegaMenuHeaderProps {
  section: SubnavSection;
}

interface SubnavLinksSectionProps {
  section: SubnavSection;
}

const LinkSection: React.FC<LinkSectionProps> = ({ url, children }) => {
  const { main } = useNavigation();
  const onClick = React.useCallback(
    (event: React.MouseEvent) => {
      const isSectionActive = window.location.pathname === url;
      if (isSectionActive) {
        event.preventDefault();
        main.close();
      }
    },
    [main.close, window.location.pathname],
  );
  return (
    <Link
      className={Styles.MegaMenu__Link}
      to={url}
      alignItems="start"
      variant="plain"
      onClick={onClick}
    >
      {children}
    </Link>
  );
};

const MegaMenuHeader: React.FC<MegaMenuHeaderProps> = ({ section }) => {
  const contents = (
    <Box className={Styles.MegaMenu__Header}>
      <div className={Styles.MegaMenu__Header__Container}>
        <div className={Styles.MegaMenu__Header__Container__Headline}>
          {section.section}
        </div>
      </div>
      {section.showDescription && (
        <Text className={Styles.MegaMenu__Header__Description}>
          {section.description}
        </Text>
      )}
    </Box>
  );
  return (
    <>
      {section.url ? (
        <LinkSection url={section.url}>{contents}</LinkSection>
      ) : (
        contents
      )}
    </>
  );
};

const SubnavLinksSection: React.FC<SubnavLinksSectionProps> = ({ section }) => {
  return (
    <>
      <MegaMenuHeader section={section} />
      <div className={Styles.MegaMenuLinksContainer}>
        {section.items.map((item, index) => {
          return (
            <LinkSection key={index} url={item.url}>
              <div className={Styles.MegaMenu__Link__Header}>{item.item}</div>
              {item.showDescription && (
                <Text className={Styles.MegaMenu__Link__Description}>
                  {item.description}
                </Text>
              )}
            </LinkSection>
          );
        })}
      </div>
    </>
  );
};

export default SubnavLinksSection;
